import { useRef, useEffect } from 'react'

import { createStudio } from '@mux/studio-embed'

import PlayerService from 'modules/player/service'

const EMPTY_MUX_STUDIO_ID_ERROR = 'EMPTY_MUX_STUDIO_ID_ERROR'

interface MuxStudioProps {
  muxStudioId?: string
}

const MuxStudio = ({ muxStudioId }: MuxStudioProps) => {
  const ref = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const init = async () => {
      try {
        if (!muxStudioId) {
          throw new Error(EMPTY_MUX_STUDIO_ID_ERROR)
        }

        const token = await PlayerService.getMuxstudioToken(muxStudioId)

        ref.current && createStudio(token, ref.current)
      } catch (error) {
        console.error(error)
      }
    }

    init()
  }, [muxStudioId])

  return <div className="mux-studio-container" data-test="mux-studio" ref={ref} />
}

export default MuxStudio
